{
  "orders": {
    "ticker": "Тикер",
    "tickerCompany": "Тикер/Комп",
    "operation": "Операция",
    "quantity": "Кол-во",
    "sum": "Сумма",
    "executed": "Исполнено",
    "profitability": "Доходность",
    "dateTime": "Дата/Время",
    "price": "Цена",
    "openedOrders": "Открытые ордера",
    "complexOrders": "Группа ордеров",
    "statusTitle": "Статус",
    "term": "Срок",
    "orderStatus": "Статус ордера",
    "orderType": "Тип ордера",
    "info": "Информация",
    "pcs": "шт.",
    "total": "Всего",
    "status": {
      "new": "Новый",
      "partially_filled": "Частично",
      "filled": "Исполнен",
      "done_for_day": "Завершен на сегодня",
      "canceled": "Отменен",
      "expired": "Истек",
      "replaced": "Заменен",
      "pending_cancel": "Ожидает отмены",
      "pending_replace": "Ожидает замены",
      "accepted": "В обработке",
      "pending_new": "Ожидает создания",
      "rejected": "Отклонен",
      "calculated": "Вычисляется",
      "accepted_for_bidding": "Принят на торги",
      "stopped": "Остановлен",
      "suspended": "Приостановлен",
      "held": "Ожидает"
    },
    "side": {
      "buy": "Купить",
      "sell": "Продать",
      "sell_short": "Продажа в шорт"
    },
    "activeOrders": {
      "filled": "Исполненные",
      "open": "Открытые",
      "canceled": "Отмененные"
    },
    "types": {
      "market": "Рыночный",
      "limit": "Лимитный",
      "stop": "Стоп",
      "stop_limit": "Стоп-лимитный",
      "trailing_stop": "Трейлинг-стоп"
    },
    "attributes": {
      "stop_loss": "Stop Loss",
      "take_profit": "Take Profit"
    },
    "terms": {
      "day": "DAY",
      "gtc": "GTC",
      "opg": "OPG",
      "cls": "CLS",
      "ioc": "IOC",
      "dayPlus": "DAY+"
    },
    "orderSuccessfullyCanceled": "Ордер успешно отменен!",
    "orderSuccessfullyChanged": "Ордер успешно изменен!",
    "couldn'tChangeOrder": "Не удалось изменить ордер.",
    "couldn'tCancelOrder": "Не удалось отменить ордер.",
    "empty": "Отсутствуют ордера",
    "cancel": "Отменить",
    "edit": "Изменить"
  }
}
